// Code generated by Slice Machine. DO NOT EDIT.
// @ts-nocheck
import {defineSliceZoneComponents} from '@prismicio/vue';

import Columns from './Columns/index.vue';
import ContentColumns from './ContentColumns/index.vue';
import ContentGrid from './ContentGrid/index.vue';
import Cta from './Cta/index.vue';
import Embeded from './Embeded/index.vue';
import Faq from './Faq/index.vue';
import Features from './Features/index.vue';
import Form from './Form/index.vue';
import Hero from './Hero/index.vue';
import HubspotSlice from './HubspotSlice/index.vue';
import InvitationVerbatim from './InvitationVerbatim/index.vue';
import List from './List/index.vue';
import Media from './Media/index.vue';
import Numbers from './Numbers/index.vue';
import PersonaContentSlice from './PersonaContentSlice/index.vue';
import PictureGallery from './PictureGallery/index.vue';
import Pricing from './Pricing/index.vue';
import Profiles from './Profiles/index.vue';
import Reinsurance from './Reinsurance/index.vue';
import ReinsuranceSlice from './ReinsuranceSlice/index.vue';
import RichText from './RichText/index.vue';
import Stepper from './Stepper/index.vue';
import Testimonials from './Testimonials/index.vue';
import Versus from './Versus/index.vue';
import VersusComparison from './VersusComparison/index.vue';
import Video from './Video/index.vue';
import VideoSlice from './VideoSlice/index.vue';

export const components = defineSliceZoneComponents({
    columns: Columns,
    content_columns: ContentColumns,
    content_grid: ContentGrid,
    cta: Cta,
    embeded: Embeded,
    faq: Faq,
    features: Features,
    form: Form,
    hero: Hero,
    hubspot_slice: HubspotSlice,
    invitation_verbatim: InvitationVerbatim,
    list: List,
    media: Media,
    numbers: Numbers,
    persona_content_slice: PersonaContentSlice,
    picture_gallery: PictureGallery,
    pricing: Pricing,
    profiles: Profiles,
    reinsurance: Reinsurance,
    reinsurance_slice: ReinsuranceSlice,
    rich_text: RichText,
    stepper: Stepper,
    testimonials: Testimonials,
    versus: Versus,
    versus_comparison: VersusComparison,
    video: Video,
    video_slice: VideoSlice,
});
